export enum StageName {
  Local = 'local',
  Development = 'dev',
  Staging = 'stg',
  Production = 'prd',
}
